export const randomInt = (fr, to) => {
  return Math.round(fr + Math.random() * to)
}

export const generateRGBColors = (count) => {
  return Array.apply(null, new Array(count)).map((none, i) => {
    return {
      r: randomInt(0, 255),
      g: randomInt(0, 255),
      b: randomInt(0, 255)
    }
  })
}
// 格式化路由参数
export const serializeParams = data => {
  let str = ''

  for (let i in data) {
    str += `${i}=${data[i]}&`
  }
  return str.slice(0, str.length - 1)
}

export const getUrlToken = (url) => {
  url = decodeURIComponent(url).replace('?', '').split('&')
  let urlKeyArr = {}
  url.forEach(item => {
    if (item.substr(0, 5) == 'token') {
      urlKeyArr.token = item.substr(6, item.length - 1)
    } else {
      item.replace(/(.+)=(.+)/g, function (a, b, c) {
        urlKeyArr[b] = c
      })
    }
  })
  return urlKeyArr
}

export const GetDistance = (lat1, lng1, lat2, lng2) => {
  let radLat1 = lat1 * Math.PI / 180.0
  let radLat2 = lat2 * Math.PI / 180.0
  let a = radLat1 - radLat2
  let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0
  let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
  Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
  s = s * 6378.137 // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000
  return (s * 1000).toFixed(2)
}

export const isIos = ()=> {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if(isAndroid){
    return false
  }
  else {
    return true
  }
}

export const amendPictureProperty = (data) => {
  if(!data) return null
  return data.replace(/\<img/gi, '<img style="width:100%;height:auto;display: block"')
             .replace(/<section/g, '<div')
             .replace(/\/section>/g, '\div>').replace(/src="http:/gi, 'src="https:').replace(/width="\d{1,5}"/g, 'width="100%" height="auto"').replace(/width="\d{1,5}px"/g, 'width="100%" height="auto"')
}


 export const compatibleAndroid = () => {
  // 监听安卓手机底部键盘显示或隐藏时更改地图高度

  let mapTop = document.getElementById("mapTop");

  let height = document.documentElement.clientHeight;

  mapTop.style.height = parseInt(height) - 52 + "px";

  window.onresize = () => {
    let height = document.documentElement.clientHeight;

    mapTop.style.height = parseInt(height) - 52 + "px";
  };

  mapTop.style.fontSize = 16 + "px";
}

export function ajaxObject() {
  var xmlHttp;
  try {
    // Firefox, Opera 8.0+, Safari
    xmlHttp = new XMLHttpRequest();
  } catch (e) {
    // Internet Explorer
    try {
      xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (e) {
      try {
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {
        // alert("您的浏览器不支持AJAX！");
        return false;
      }
    }
  }
  return xmlHttp;
}
export default {
  randomInt,
  generateRGBColors,
  serializeParams,
  getUrlToken,
  GetDistance,
  isIos
}



// WEBPACK FOOTER //
// ./src/utils/util.js